export default {
	profileFollowers: [],
	profileFollowersLimit: 10,
	profileFollowersOffset: 0,
	profileFollowersFetchCompleted: false 
}